import phoneCardHeader from 'assets/images/signup/phone-card-header.png';
import { useTranslation } from 'react-i18next';
import {
  Image,
  ImageSourcePropType,
  StyleSheet,
  useWindowDimensions,
  View,
} from 'react-native';
import ExpressiveMdText from 'shared/components/vxl/typography/expressive/ExpressiveMdText';
import ExpressiveSmText from 'shared/components/vxl/typography/expressive/ExpressiveSmText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { isDesktopBrowser } from 'shared/constants/platform';
import theme from 'shared/styles/theme';

// Below this width the longest headline word cannot fit at ExpressiveMd size
export const NARROW_HEADER_MAX_WIDTH = 342;

export interface SignupHeaderVariantProps {
  headerText: string;
  subHeadText: string;
  headerTextColor: string;
  headerBackgroundColor: string;
  headerSubHeadTextColor: string;
}

const SignupHeaderVariant = ({
  headerText,
  subHeadText,
  headerTextColor,
  headerBackgroundColor,
  headerSubHeadTextColor,
}: SignupHeaderVariantProps) => {
  const { t: translatedText } = useTranslation('signup', {
    keyPrefix: 'createAccount',
  });
  const { width } = useWindowDimensions();
  const HeadlineText =
    width < NARROW_HEADER_MAX_WIDTH ? ExpressiveSmText : ExpressiveMdText;

  return (
    <View
      style={[
        styles.headerContainer,
        {
          backgroundColor:
            headerBackgroundColor || theme.color.expressive.orchid,
        },
      ]}
    >
      <View style={styles.header}>
        <HeadlineText
          style={[styles.headerText, { color: headerTextColor }]}
          numberOfLines={0}
        >
          {translatedText(headerText)}
        </HeadlineText>
        <Image
          style={styles.headerImage}
          source={phoneCardHeader as ImageSourcePropType}
          accessibilityRole="image"
          accessibilityLabel={translatedText('header.variantHeaderImageLabel')}
          role="img"
        />
      </View>
      {subHeadText ? (
        <BodyBaseText
          style={[styles.subHeader, { color: headerSubHeadTextColor }]}
          numberOfLines={0}
        >
          {translatedText(subHeadText)}
        </BodyBaseText>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  header: {
    alignItems: 'flex-end',
    flexDirection: 'row',
    justifyContent: 'center',
  },
  headerContainer: {
    backgroundColor: theme.color.expressive.orchid,
    flex: 1,
    width: '100%',
    paddingTop: theme.spacing.m,
  },
  headerImage: {
    height: 150,
    paddingRight: theme.spacing.s,
    resizeMode: 'contain',
    width: '45%',
  },
  headerText: {
    alignSelf: 'flex-end',
    color: theme.color.expressive.varoPurple,
    flex: 1,
    paddingBottom: theme.spacing.s,
    paddingLeft: theme.spacing.m,
    paddingRight: isDesktopBrowser ? '25%' : theme.spacing.s,
    textAlign: 'left',
  },
  subHeader: {
    color: theme.color.text.primary,
    paddingBottom: theme.spacing.m,
    paddingHorizontal: theme.spacing.m,
    paddingTop: theme.spacing.m,
  },
});

export default SignupHeaderVariant;
